export function getApiOrigin() {
  const raw = process.env.REACT_APP_API_URL || '/api';

  // If API url is relative (e.g. "/api"), assets should be loaded from same origin.
  if (raw.startsWith('/')) return window.location.origin;

  // If API url is absolute (e.g. "https://host/api"), strip the "/api" suffix.
  try {
    const url = new URL(raw);
    url.pathname = url.pathname.replace(/\/api\/?$/, '');
    url.search = '';
    url.hash = '';
    return url.toString().replace(/\/$/, '');
  } catch {
    // Fallback: treat as same-origin
    return window.location.origin;
  }
}

export function resolvePracticeLogoUrl(practiceLogo, options = {}) {
  if (!practiceLogo) return null;
  const raw = String(practiceLogo).trim();
  if (!raw) return null;

  let resolved;
  if (raw.startsWith('http://') || raw.startsWith('https://')) {
    resolved = raw;
  } else if (raw.startsWith('/')) {
    // Most common backend format: "/uploads/practice-logos/<filename>"
    resolved = raw.startsWith('/uploads/')
      ? `${getApiOrigin()}/api${raw}`
      : `${getApiOrigin()}${raw}`;
  } else if (raw.startsWith('uploads/')) {
    // Some older records may store "uploads/..."
    resolved = `${getApiOrigin()}/api/${raw}`;
  } else {
    // Filename-only fallback for older/migrated records.
    resolved = `${getApiOrigin()}/api/uploads/practice-logos/${raw}`;
  }

  const cacheBust = options?.cacheBust;
  if (!cacheBust) return resolved;

  const separator = resolved.includes('?') ? '&' : '?';
  return `${resolved}${separator}v=${encodeURIComponent(String(cacheBust))}`;
}

export function resolvePatientProfileUrl(profilePathRaw) {
  if (!profilePathRaw) return null;
  const raw = String(profilePathRaw).trim().replace(/\\/g, '/');
  if (!raw) return null;
  if (raw.startsWith('http://') || raw.startsWith('https://') || raw.startsWith('data:')) return raw;

  // Normalize common API-returned path variants to static uploads paths.
  if (raw.startsWith('/api/uploads/')) return `${getApiOrigin()}${raw}`;
  if (raw.startsWith('/uploads/')) return `${getApiOrigin()}/api${raw}`;
  if (raw.startsWith('api/uploads/')) return `${getApiOrigin()}/${raw}`;
  if (raw.startsWith('uploads/')) return `${getApiOrigin()}/api/${raw}`;
  if (/^patient-images\//i.test(raw) || /^patient-documents\//i.test(raw)) return `${getApiOrigin()}/api/uploads/${raw}`;
  if (raw.includes('/uploads/')) return `${getApiOrigin()}/api${raw.substring(raw.toLowerCase().indexOf('/uploads/'))}`;

  // Filename-only fallback.
  return `${getApiOrigin()}/api/uploads/patient-images/${raw}`;
}

